import React, { useState } from 'react';
import { Button, Input, Spin } from 'antd';
import dayjs from 'dayjs';
import { INote } from '../../api/dataverse';

const { TextArea } = Input;

interface QuoteInternalNotesProps {
  existingNotes?: string | null;
  notes?: INote[];
  isLoadingNotes?: boolean;
  onAddNote: (note: string) => void;
}

export const QuoteInternalNotes: React.FC<QuoteInternalNotesProps> = ({
  existingNotes,
  notes,
  isLoadingNotes,
  onAddNote,
}) => {
  const [newNote, setNewNote] = useState('');

  const handleAdd = () => {
    if (!newNote.trim()) return;
    onAddNote(newNote.trim());
    setNewNote('');
  };

  return (
    <div className="bg-white rounded-lg p-6">
      <h3 className="text-xl font-bold text-gray-900 text-left mb-4">Internal Notes</h3>
      <TextArea
        rows={4}
        placeholder="Add internal note (not visible to customer)..."
        value={newNote}
        onChange={(e) => setNewNote(e.target.value)}
        className="mb-4"
        style={{ resize: 'none' }}
      />
      <div className="flex justify-end">
        <Button type="primary" onClick={handleAdd} disabled={!newNote.trim()}>
          Add Note
        </Button>
      </div>

      {isLoadingNotes ? (
        <div className="mt-6 flex justify-center">
          <Spin size="small" />
        </div>
      ) : notes && notes.length > 0 ? (
        <div className="mt-6">
          <h4 className="text-sm font-semibold text-left text-gray-700 mb-3">Notes</h4>
          <div className="flex flex-col gap-3">
            {notes.map((note) => (
              <div
                key={note.annotationid}
                className="bg-gray-50 text-left border border-gray-200 rounded-lg p-4"
              >
                {note.subject && (
                  <p className="text-sm font-semibold text-gray-900 mb-1">{note.subject}</p>
                )}
                <p className="text-sm text-gray-700 whitespace-pre-wrap">{note.notetext}</p>
                {note.createdon && (
                  <p className="text-xs text-gray-400 mt-2">
                    {dayjs(note.createdon).format('DD MMM YYYY, HH:mm')}
                  </p>
                )}
              </div>
            ))}
          </div>
        </div>
      ) : null}

      {existingNotes && (
        <div className="mt-6">
          <h4 className="text-sm font-semibold text-left text-gray-700 mb-3">Notes</h4>
          <div className="bg-gray-50 text-left border border-gray-200 rounded-lg p-4">
            <p className="text-sm text-gray-700 whitespace-pre-wrap">{existingNotes}</p>
          </div>
        </div>
      )}
    </div>
  );
};
